module.exports = __webpack_public_path__ + "media/images/menu/cepheus-2d2e3cb86781382dd3524511a2fb1447.jpg";